import { render, staticRenderFns } from "./ListReportAccessRequestedGDS.vue?vue&type=template&id=69c4e18a&lang=pug"
import script from "./ListReportAccessRequestedGDS.vue?vue&type=script&lang=js"
export * from "./ListReportAccessRequestedGDS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c4e18a')) {
      api.createRecord('69c4e18a', component.options)
    } else {
      api.reload('69c4e18a', component.options)
    }
    module.hot.accept("./ListReportAccessRequestedGDS.vue?vue&type=template&id=69c4e18a&lang=pug", function () {
      api.rerender('69c4e18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/ListReportAccessRequestedGDS.vue"
export default component.exports